export interface ErrorAction {
  type: string;
}

const errors = (state = {}, action: ErrorAction,) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default errors;
